import React from 'react'
import { Chip } from '@enterprise-ui/canvas-ui-react'
import { CaseResponse } from './Queries'
import { Section, SectionItem } from './Section'
import { useProfile } from '../../Layout/UserProfile/UserProfileProvider'
import { CaseStatus, CaseType } from '../Services/ConstantData'
import useInternalReopen from '../Hooks/useInternalReopen'

interface MainProp {
  heading: string
  workflowDetails: CaseResponse | undefined
  attachments?: number | undefined
}

const EditWorkflowDetails: React.FC<MainProp> = ({
  heading,
  workflowDetails,
  attachments,
}) => {
  const { userProfile } = useProfile()
  const vendor = userProfile?.isVendor
  const { isInternalReopenKnown, isInternalReopen: internalOpened } =
    useInternalReopen(workflowDetails)
  // Keep this a truthy check - the API has been seen returning `isReopen` as a
  // non-boolean, and a strict `=== true` silently hid the whole block.
  const showReopenRows =
    (workflowDetails?.caseType === CaseType.DISPUTE ||
      workflowDetails?.caseType === CaseType.INTERNALPROCESSING) &&
    !!workflowDetails?.isReopen
  let caseStatus = ''
  let color: 'default' | 'alert' | 'success' = 'default'
  if (vendor && workflowDetails?.status === CaseStatus.NEW) {
    color = 'default'
    caseStatus = CaseStatus.SUBMITTED
  } else if (!vendor && workflowDetails?.status === CaseStatus.NEW) {
    color = 'default'
    caseStatus = workflowDetails?.status
  } else if (
    workflowDetails?.status === CaseStatus.INPROGRESS ||
    workflowDetails?.status === CaseStatus.AWAITINGINFO ||
    workflowDetails?.status === CaseStatus.REOPEN
  ) {
    color = 'alert'
    caseStatus = workflowDetails?.status
  } else if (
    workflowDetails?.status === CaseStatus.RESOLVED ||
    workflowDetails?.status === CaseStatus.CLOSED
  ) {
    color = 'success'
    caseStatus = workflowDetails?.status
  }
  return (
    <Section labelGridSize={3} detail heading={heading} expandable>
      <SectionItem key="status" label="Status">
        <Chip size="dense" color={color} className="hc-txt-uppercase">
          {caseStatus}
        </Chip>
      </SectionItem>
      <SectionItem key="attachments" label="Attachments">
        <Chip size="dense" className="hc-txt-uppercase hc-bg-grey04">
          {attachments !== undefined && attachments > 0
            ? 'Available'
            : 'Not Available'}
        </Chip>
      </SectionItem>
      {!vendor && (
        <SectionItem key="workflow" label="Workflow">
          {workflowDetails?.workflow}
        </SectionItem>
      )}
      {!vendor && (
        <SectionItem key="assignee" label="Assignee">
          {workflowDetails?.userProfile?.firstName}{' '}
          {workflowDetails?.userProfile?.secondName}
        </SectionItem>
      )}
      {!vendor && showReopenRows && (
        <SectionItem key="reopened" label="Reopened Case">
          <Chip size="dense" color="alert">
            YES
          </Chip>
        </SectionItem>
      )}
      {!vendor && (
        <SectionItem key="internalReopened" label="Internal ReOpened">
          {isInternalReopenKnown ? (
            <Chip size="dense" color={internalOpened ? 'alert' : 'default'}>
              {internalOpened ? 'YES' : 'NO'}
            </Chip>
          ) : undefined}
        </SectionItem>
      )}
      <SectionItem key="reporter" label="Reporter">
        {workflowDetails?.createUser}
      </SectionItem>
    </Section>
  )
}

export default EditWorkflowDetails
